import React from 'react';
import resume from '../assets/images/resume.jpeg';  
import '../pages/Resume.css';
import { Helmet } from 'react-helmet';

function Resume() {
  return <div className='contaier'>
    <Helmet>
      <title>Aadhaar Koul | Resume</title>
    </Helmet>
    <div className='discount'>
      <a href="/shop"><p>Get upto 75% off on my online Store →</p></a>
    </div>
    <div className='resume'>
      <img src={resume}></img>
    </div>
  </div>;
}

export default Resume;
